export enum MetodoPagoEnum {
    PAGO_SECURE = 1,
    EMITE_SECURE = 2,
    PAGO_ASEGURADORA = 3,
    EMITE = 4
}